"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spinner = void 0;

var _stylitas = require("@creditas/stylitas");

const spinnerLoading = ({
  complete,
  theme
}) => !complete && (0, _stylitas.css)`
    border: solid 5px ${_stylitas.utilities.palette.color(theme, 'neutral03')};
    border-bottom-color: ${_stylitas.utilities.palette.color(theme, 'primary03')};
    ${_stylitas.utilities.animation.spin()}
  `;

const spinnerComplete = ({
  complete,
  theme
}) => complete && (0, _stylitas.css)`
    border: solid 5px ${_stylitas.utilities.palette.color(theme, 'primary03')};
  `;

const spinner = ({
  complete,
  theme
}) => (0, _stylitas.css)`
  height: 62px;
  width: 62px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 50%;

  ${spinnerLoading({
  complete,
  theme
})}
  ${spinnerComplete({
  complete,
  theme
})}
`;

exports.spinner = spinner;